import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AuthenticationService } from '../core/authentication/authentication.service';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-role-selection',
    templateUrl: './role-selection.component.html',
    styleUrls: ['./role-selection.component.scss']
})
export class RoleSelectionComponent implements OnInit {
    public form: FormGroup;
    public roles: any = [];

    public constructor(
        private route: ActivatedRoute,
        private router: Router,
        private formBuilder: FormBuilder,
        private authenticationService: AuthenticationService
    ) {}

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        this.roles = this.authenticationService.currentUserValue.roles;
        this.form = this.formBuilder.group({
            role: new FormControl(null, RxwebValidators.required({ message: 'Role is required.' }))
        });
    }

    onRoleSelected() {
        if (this.form.invalid) return;

        const selectedRole = this.form.get('role').value;
        this.authenticationService.setSessionRole(selectedRole);

        const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';
        this.router.navigate([returnUrl]);
    }

    userRoles = [{ name: 'Supplier' }, { name: 'Client' }];
}
